import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { Calendar, MapPin, Users, type LucideIcon } from "lucide-react";
import { fadeUp, stagger, viewportOnce } from "./motion-presets";

const ITEMS: Array<{ key: string; icon: LucideIcon }> = [
  { key: "tracking", icon: MapPin },
  { key: "calls", icon: Users },
  { key: "scheduling", icon: Calendar },
];

export const ProblemSection = () => {
  const { t } = useTranslation("landing");
  return (
    <section className="relative py-20 px-4">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        variants={stagger}
        className="container mx-auto max-w-4xl"
      >
        <div className="text-center max-w-2xl mx-auto">
          <motion.span
            variants={fadeUp}
            className="text-xs font-medium uppercase tracking-wider text-muted-foreground"
          >
            {t("problem.eyebrow")}
          </motion.span>
          <motion.h2
            variants={fadeUp}
            className="mt-3 font-display text-3xl md:text-4xl font-semibold tracking-tight text-foreground"
          >
            {t("problem.title")}
          </motion.h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-4">
          {ITEMS.map((item) => (
            <motion.div
              key={item.key}
              variants={fadeUp}
              className="rounded-xl border border-border bg-card/40 p-6 transition-colors hover:bg-card/60"
            >
              <div className="inline-flex items-center justify-center h-10 w-10 rounded-lg bg-primary/10 mb-4">
                <item.icon className="h-5 w-5 text-primary" />
              </div>
              <p className="text-sm text-foreground/80 leading-relaxed">{t(`problem.items.${item.key}`)}</p>
            </motion.div>
          ))}
        </div>

        <motion.p variants={fadeUp} className="mt-8 text-center text-sm text-muted-foreground">
          {t("problem.footnote")}
        </motion.p>
      </motion.div>
    </section>
  );
};
